import { http } from "./http.js";

async function getGoodsDetail(id) {
  const response = await http.get(`goods-details/${id}`);
  return response;
}

async function getGoodsDetailsItems(id) {
  const response = await http.get(`goods-details/${id}/items`);
  const emptyObj = {
    id: 0,
    title: "",
  };
  return {
    totalInfo: {
      totalCargoPlaces: response.data.TotalCargoPlaces,
      totalVolume: response.data.TotalVolume,
      totalWeightBrutto: response.data.TotalWeightBrutto,
      totalWeightNetto: response.data.TotalWeightNetto,
      totalCost: response.data.TotalCost,
      totalQuantity: response.data.TotalQuantity,
    },
    items: response.data.Items.map((i) => {
      return {
        id: i.Id,
        article: i.Article
          ? {
            id: i.Article.Id,
            title: i.Article.Title,
          }
          : emptyObj,
        country: i.Country
          ? {
            id: i.Country.Id,
            title: i.Country.Title,
          }
          : emptyObj,
        goodSite: i.GoodSite,
        material: i.Material,
        manufacturer: i.Manufacturer
          ? {
            id: i.Manufacturer.Id,
            title: i.Manufacturer.Title,
          }
          : emptyObj,
        model: i.Model
          ? {
            id: i.Model.Id,
            title: i.Model.Title,
          }
          : emptyObj,
        nomenclature: i.Nomenclature
          ? {
            id: i.Nomenclature.Id,
            title: i.Nomenclature.Title,
          }
          : emptyObj,
        places: i.Places,
        quantity: i.Quantity,
        size: i.Size,
        trademark: i.Trademark
          ? {
            id: i.Trademark.Id,
            title: i.Trademark.Title,
          }
          : emptyObj,
        unit: i.Unit
          ? {
            id: i.Unit.Id,
            title: i.Unit.Title,
          }
          : emptyObj,
        weightBrutto: i.WeightBrutto,
        weightNetto: i.WeightNetto,
        volume: i.Volume,
        fragile: i.Fragile,
        factoryMarking: i.FactoryMarking ? i.FactoryMarking : "",
        productCategory: i.ProductCategory
          ? {
            id: i.ProductCategory.Id,
            title: i.ProductCategory.Title,
          }
          : emptyObj,
        notes: i.Notes,
        cost: i.Cost ? i.Cost : 0,
        customsNumber: i.CustomsNumber ? i.CustomsNumber : "",
        currency: i.Currency?.Title || "",
      };
    }),
  };
}

async function updateGoodsDetailsItems(id, updateItemsList) {
  const response = await http.put(`goods-details/${id}/items`, updateItemsList);
  return response;
}

async function changeManagerByDesription(id, newValue) {
  const response = await http.patch(
    `goods-details/${id}/manager-by-description`,
    {
      value: newValue?.id || newValue,
    }
  );
  return response;
}

async function updateWeightBrutto(resource, val) {
  const response = await http.patch(`${resource}/weight-brutto`, {
    value: val,
  });
  return response;
}

async function updateWeightNetto(resource, val) {
  const response = await http.patch(`${resource}/weight-netto`, {
    value: val,
  });
  return response;
}

async function editGoodsDetailItem(item) {
  const response = await http.post("goods-details/rpc/item/compare", item);
  return response;
}

async function deleteItem(id, itemId) {
  const response = await http.delete(`goods-details/${id}/items/${itemId}`);
  return response;
}

async function deleteItemUnrestricted(id, itemId) {
  const response = await http.delete(`goods-details/${id}/items/${itemId}/unrestricted`);
  return response;
}

async function addItem(id, newItem) {
  const response = await http.post(`goods-details/${id}/items`, newItem);
  return response;
}

async function addItemUnrestricted(id, newItem) {
  const response = await http.post(`goods-details/${id}/items/unrestricted`, newItem);
  return response;
}

async function changeItemPosition(id, itemId, position) {
  const response = await http.patch(
    `goods-details/${id}/items/${itemId}/position`,
    { value: position }
  );
  return response;
}

async function changeTrademark(id) {
  const response = await http.get(`/trademarks/${id}`);
  return {
    id: response.data.Manufacturer.Id,
    title: response.data.Manufacturer.Title,
  };
}

async function changeNomenclature(id) {
  const response = await http.get(`/nomenclature/${id}`);
  return {
    id: response.data.Manufacturer.Id,
    title: response.data.Manufacturer.Title,
  };
}

async function getGoodsDetailsManager(resource, id) {
  const response = await http.get(`${resource}/referencies/${id}`);
  return response;
}

async function fetchAllManagers(resource) {
  const response = await http.get(`${resource}/goods-details-managers`);
  return response.data.map((i) => {
    return {
      text: i.Title,
      value: i.Id,
    };
  });
}

async function searchManager(resource, search) {
  const response = await http.get(
    `${resource}/goods-details-managers?searchTerm=${search}`
  );
  if (Array.isArray(response.data)) {
    return response.data.map((i) => {
      return {
        text: i.Title,
        value: i.Id,
      };
    });
  } else {
    response.data = [];
    return response;
  }
}

async function saveItems(changesInfo) {
  const response = await http.post(
    "goods-details/rpc/item/save-in-catalogs",
    changesInfo
  );
  return response;
}

async function changeLabel(id, label, value) {
  const response = await http.patch(`goods-details/${id}/lables/${label}`, {
    value,
  });
  return response;
}

async function changeLabelUnrestricted(id, label, value) {
  const response = await http.patch(`goods-details/${id}/lables/${label}/unrestricted`, {
    value,
  });
  return response;
}

async function changeFactoryMarking(id, value) {
  const response = await http.patch(`goods-details/${id}/factory-marking`, {
    value,
  });
  return response;
}

async function createNomenclature(title) {
  const response = await http.post("nomenclatures", {
    title,
  });
  return response;
}

async function createUnit(title) {
  const response = await http.post("units", {
    title,
  });
  return response;
}

async function createManufacturer(title) {
  const response = await http.post("manufacturers", {
    title,
  });
  return response;
}

async function createTrademark(title, id) {
  const response = await http.post("trademarks", {
    title,
    manufacturerId: id,
  });
  return response;
}

async function createModel(model) {
  const response = await http.post("trademark-models", model);
  return response;
}

async function createArticle(article) {
  const response = await http.post("articles", article);
  return response;
}

async function getCategoriesInfo(id) {
  const response = await http.get(`goods-details/${id}/categories-info`);
  return response.data.map((i) => {
    return {
      id: i.Id,
      category: i.Category
        ? { id: i.Category.Id, title: i.Category.Title }
        : null,
      volume: i.Volume,
      weightBrutto: i.Weight,
      cargoPlaces: i.CargoPlaces,
    };
  });
}

async function createCategoriesInfo(id, info) {
  const response = await http.post(`goods-details/${id}/categories-info`, info);
  return response;
}

async function createCategoriesInfoUnrestricted(id, info) {
  const response = await http.post(
    `goods-details/${id}/categories-info/unrestricted`,
    info
  );
  return response;
}

async function updateCategoriesInfo(id, infoId, info) {
  const response = await http.patch(
    `goods-details/${id}/categories-info/${infoId}`,
    info
  );
  return response;
}

async function updateCategoriesInfoUnrestricted(id, infoId, info) {
  const response = await http.patch(
    `goods-details/${id}/categories-info/${infoId}/unrestricted`,
    info
  );
  return response;
}

async function deleteCategoriesInfo(id, infoId) {
  const response = await http.delete(
    `/goods-details/${id}/categories-info/${infoId}`
  );
  return response;
}

async function deleteCategoriesInfoUnrestricted(id, infoId) {
  const response = await http.delete(
    `/goods-details/${id}/categories-info/${infoId}/unrestricted`
  );
  return response;
}

async function getReferencies(resource, queryParams) {
  const response = await http.get(`${resource}/referencies?${queryParams}`);
  return response.data.map((i) => {
    return {
      text: i.Title,
      value: i.Id,
    };
  });
}

async function downloadOutputForm(id) {
  const response = await http.get(`goods-details/${id}/output-xlsx`, {
    responseType: "arraybuffer",
  });
  return response;
}

async function changeInvoiceSum(id, value) {
  const response = await http.patch(`goods-details/${id}/invoice-sum`, {
    value,
  });
  return response;
}

async function changeCurrency(id, currencyId) {
  const response = await http.patch(`goods-details/${id}/currency`, {
    value: currencyId,
  });
  return response;
}

async function createNote(id, note) {
  const response = await http.post(`/goods-details/${id}/notes`, {
    text: note,
  });
  return response;
}

async function updateNote(id, noteId, note) {
  const response = await http.put(`/goods-details/${id}/notes/${noteId}`, {
    text: note,
  });
  return response;
}

async function deleteNote(id, noteId) {
  const response = await http.delete(`/goods-details/${id}/notes/${noteId}`);
  return response;
}

async function getNotes(id) {
  const response = await http.get(`/goods-details/${id}/notes`);
  return response.data.map((n) => {
    return {
      id: n.Id,
      text: n.Text,
      changedAt: n.ChangedAt,
      author: n.Author,
    };
  });
}

async function updateTotalCargoPlacesFact(id, totalCargoPlacesFact) {
  const response = await http.patch(`goods-details/${id}/places-fact`, {
    value: totalCargoPlacesFact,
  });
  return response;
}

async function importItems(id, value) {
  const item = {
    data: value.data,
    type: value.type,
    originName: value.originName,
  };
  const response = await http.post(`/goods-detail-items/${id}/import`, item);
  return response.data.map((i) => {
    return {
      article: i.Article
        ? {
          id: i.Article.Id,
          title: i.Article.Title,
        }
        : null,
      articleOrigin: i.ArticleOrigin,
      country: i.Country
        ? {
          id: i.Country.Id,
          title: i.Country.Title,
        }
        : null,
      countryOrigin: i.CountryOrigin,
      goodSite: i.GoodSite,
      material: i.Material,
      manufacturer: i.Manufacturer
        ? {
          id: i.Manufacturer.Id,
          title: i.Manufacturer.Title,
        }
        : null,
      manufacturerOrigin: i.ManufacturerOrigin,
      model: i.Model
        ? {
          id: i.Model.Id,
          title: i.Model.Title,
        }
        : null,
      modelOrigin: i.ModelOrigin,
      nomenclature: i.Nomenclature
        ? {
          id: i.Nomenclature.Id,
          title: i.Nomenclature.Title,
        }
        : null,
      nomenclatureOrigin: i.NomenclatureOrigin,
      places: i.Places,
      placesOrigin: i.PlacesOrigin,
      quantity: i.Quantity,
      quantityOrigin: i.QuantityOrigin,
      size: i.Size,
      trademark: i.Trademark
        ? {
          id: i.Trademark.Id,
          title: i.Trademark.Title,
        }
        : null,
      trademarkOrigin: i.TrademarkOrigin,
      unit: i.Unit
        ? {
          id: i.Unit.Id,
          title: i.Unit.Title,
        }
        : null,
      unitOrigin: i.UnitOrigin,
      weightBrutto: i.WeightBrutto,
      weightBruttoOrigin: i.WeightBruttoOrigin,
      weightNetto: i.WeightNetto,
      weightNettoOrigin: i.WeightNettoOrigin,
      volume: i.Volume,
      volumeOrigin: i.VolumeOrigin,
      factoryMarking: i.FactoryMarking ? i.FactoryMarking : "",
      factoryMarkingOrigin: i.FactoryMarkingOrigin,
      productCategory: i.ProductCategory
        ? {
          id: i.ProductCategory.Id,
          title: i.ProductCategory.Title,
        }
        : null,
      productCategoryOrigin: i.ProductCategoryOrigin,
      notes: i.Notes,
      cost: i.Cost ? i.Cost : 0,
      costOrigin: i.CostOrigin,
      customsNumber: i.CustomsNumber ? i.CustomsNumber : "",
      currency: i.Currency
        ? {
          id: i.Currency.Id,
          title: i.Currency.Title,
        }
        : null,
    };
  });
}

async function removeGoodsDetailsItems(id) {
  const response = await http.delete(`goods-details/${id}/items`);
  return response;
}

async function updateGoodsDetailsItem(id, itemId, item) {
  const response = await http.put(`goods-details/${id}/items/${itemId}`, item);
  return response;
}

async function updateGoodsDetailsItemUnrestricted(id, itemId, item) {
  const response = await http.put(`goods-details/${id}/items/${itemId}/unrestricted`, item);
  return response;
}

/**
 * @param {Array<number>} ids - The list of product IDs to update.
 * @param {Object} newValues - The object containing the new values to update for each product.
 * @param {number} newValues.goodDetailsId - The good details ID.
 * @param {number} [newValues.productCategoryId] - The new product category ID.
 * @param {string} [newValues.customsNumber] - The new customs number.
 * @param {string} [newValues.factoryMarking] - The new factory marking.
 * @returns {Promise<Object>} - The response from the bulk update API.
 */
async function bulkUpdate(ids, newValues) {
  const response = await http.patch("goods-details/bulk", {
    ids,
    ...newValues,
  });
  return response;
}

/**
 * @param {Array<number|string>} ids - Array of IDs to be deleted.
 * @param {number} goodDetailsId - The good details ID.
 * @returns {Promise<object>} - The HTTP response object.
 */
async function bulkDelete(ids, goodDetailsId) {
  const response = await http.delete("goods-details/bulk", {
    params: { ids, goodDetailsId },
  });
  return response;
}

/**
 * @param {Array<number>} ids - The list of product IDs to update.
 * @param {number} [brutto] - The number containing the total brutto weight of specified products (optional).
 * @param {number} [netto] - The number containing the total netto weight of specified products (optional).
 * @returns {Promise<Object>} - The response from the bulk weight update API.
 */
async function bulkBruttoWeightUpdate(ids, brutto, netto) {
  const response = await http.patch("goods-details/bulkWeight", {
    ids,
    brutto,
    netto,
  });
  return response;
}

export {
  getGoodsDetail,
  getGoodsDetailsItems,
  updateGoodsDetailsItems,
  changeManagerByDesription,
  updateWeightBrutto,
  editGoodsDetailItem,
  changeTrademark,
  changeNomenclature,
  getGoodsDetailsManager,
  fetchAllManagers,
  searchManager,
  saveItems,
  changeLabel,
  changeFactoryMarking,
  createNomenclature,
  createUnit,
  createManufacturer,
  createTrademark,
  createModel,
  createArticle,
  getCategoriesInfo,
  createCategoriesInfo,
  updateCategoriesInfo,
  deleteCategoriesInfo,
  deleteItem,
  addItem,
  changeItemPosition,
  updateWeightNetto,
  getReferencies,
  downloadOutputForm,
  changeInvoiceSum,
  changeCurrency,
  createNote,
  updateNote,
  deleteNote,
  getNotes,
  updateTotalCargoPlacesFact,
  importItems,
  removeGoodsDetailsItems,
  updateGoodsDetailsItem,
  bulkUpdate,
  bulkDelete,
  bulkBruttoWeightUpdate,
  createCategoriesInfoUnrestricted,
  updateCategoriesInfoUnrestricted,
  deleteCategoriesInfoUnrestricted,
  changeLabelUnrestricted,
  addItemUnrestricted,
  updateGoodsDetailsItemUnrestricted,
  deleteItemUnrestricted,
};
